import React from 'react'
import { Box, Grid, Typography,Container, Paper } from "@mui/material";
import imgUrl from "../../assets/images/imgUrl";

const highlights = [
  {
    title: "Contribution",
    description: <>
      Open to all <b>I Am Peacekeeper </b>  members and communities worldwide.
    </>,
    colorClass: "gradient-blue",
    image: imgUrl.contriIcon,
  },
  {
    title: "Eligibility",
    description: <>
     Anyone who embraces the <b> 7 Human Values </b> and the pledge <b> <i>I Am Peacekeeper. </i> </b> 
    </>,
    colorClass: "gradient-yellow",
    image: imgUrl.eligibilityIcon,
  },
  {
    title: "Goal",
    description: "Create warm, informal spaces where people connect, share and heal through Peace.",
    colorClass: "gradient-blue",
    image: imgUrl.goalIcon,
  },
  {
    title: "Global reach",
    description: <>
        Flagship Cafee in <b> Mumbai </b>, expanding in <b>Kanpur </b> , with proposed Cafee hubs worldwide.
    </>,
    colorClass: "gradient-yellow",
    image: imgUrl.goalReachIcon,
  },
];

const whyJoin = [
  <>
		Enjoy a unique blend of hospitality and humanity, where every cup comes with an <b> I Am Peacekeeper Gesture.</b>
  </>,
  <>
 	Participate in the <b> I Am Peacekeeper Friendship Table  </b>  meet new friends, share stories, build trust. 
  </>,

  <>
   	Experience <b> I Am Peacekeeper Hugs </b> a choice-based symbolic act of connection and empathy.
  </>,
  <>
  	Take part in <b>I Am Peacekeeper Laughter </b>  one minute of joyful group laughter every hour. 
  </>,
  <>
   Share and receive <b>I Am Peacekeeper Gifts </b>  meaningful tokens that spread kindness and unity. 
  </>,
  <>
   Reflect through <b>I Am Peacekeeper Gestures </b>  <i> Thank You, Forgiveness, Love, Joy, Positivity, Friendship and Get Well Soon </i> . 
  </>,
  <>
 Strengthen your identity as part of the <i> I Am Peacekeeper Movement </i> by living its values in a social setting. 
  </>
];

const whatExperience = [
  <>
    <b> 	I Am Peacekeeper Menu </b> <br></br> every order comes with <br></br> a Gesture of Peace. 
  </>,
  <>
    <b> 	I Am Peacekeeper Friendship Tables </b> <br></br> be friendly, share about <br></br>yourself and have fun. 
  </>,

  <>
   <b>	I Am Peacekeeper Hugs </b> <br></br>  consent-based connections <br></br> to uplift spirits.
  </>,
  <>
   <b>	I Am Peacekeeper Laughter </b> <br></br>   joyful breaks to <br></br> lighten the heart.
  </>,
  <>
      <b>	I Am Peacekeeper Gifts </b> <br></br><i>  Chocs, Cap, Candle, Mug, Fragrance, Candy and 28 Secrets of Happiness; </i>
      each crafted to inspire, support Peace and reward contributors . 
  </>,
  <>
  <b>		I Am Peacekeeper Book a Table </b> <br></br>   for special gatherings, <br></br> meet-ups and meaningful dialogue. 
  </>,
  <>
        <b>			I Am Peacekeeper Service at Table </b> <br></br>   slow down, relax and <br></br> be served with dignity. 
  </>,
  <>
       <b>				I Am Peacekeeper Gestures </b> <br></br>  practise daily acts of <br></br> kindness and empathy. 
  </>,
  <>
   <b>	I Am Peacekeeper Cafee Volunteers </b> <br></br>  local volunteers <br></br> hosting <b>Cafee</b> activities. 
  </>,
  <>
    <b>	I Am Peacekeeper Events  </b> <br></br> open mic, storytelling <br></br> and dialogue sessions.
  </>,
  <>
    <b>	Integration with the Movement </b> Cafee is a touchpoint for wider <br></br> <b> <i>I Am Peacekeeper </i> </b>  initiatives.
  </>,
  <>
 <b>	Legacy of Love </b> <br></br>  every Cafee embodies the living <br></br> practice of <b>Justice, Love & Peace. </b> 
  </>
];

const circleCourses = [
  {
    text: (
      <>
        Come, sip Peace and spread joy.
      </>
    ),
    colorClass: "gradient-blue",
  },
  {
    text: (
      <>
        	Let every cup shared be a bond created. 
      </>
    ),
    colorClass: "gradient-yellow",
  },
   {
    text: (
      <>
      	Build a community where humanity thrives.
      </>
    ),
    colorClass: "gradient-blue",
  },
  {
    text: (
      <>
      Together, let us make every <b>I Am Peacekeeper Cafee </b>  a sanctuary of <b> Justice, Love & Peace. </b>
      </>
    ),
    colorClass: "gradient-yellow",
  }
];

const InfoCard = ({ text }) => (
  <Paper elevation={3} className="infoCard">
    <Typography variant="body2" sx={{ fontFamily: 'var(--primary-font)', fontWeight: 400 }}>{text}</Typography>
  </Paper>
);

const ProgramCard = ({ text }) => (
  <Paper elevation={3} className="CircleCard">
    <Typography variant="body2" sx={{ fontFamily: 'var(--primary-font)', fontWeight: 400 }}>{text}</Typography>
  </Paper>
);

const ConclusionCard = ({ text, colorClass }) => (
  <Paper
    elevation={3}
    className={`programCard gradientTrioCards gradientTrioBigCards ${colorClass}`}
    sx={{
      width: 140,
      height: 140,
      borderRadius: "50%",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      textAlign: "center",
      padding: 2,
      m: "auto",
    }}
  >
    <Typography variant="body2" sx={{ fontFamily: 'var(--primary-font)', fontWeight: 400 }}>{text}</Typography>
  </Paper>
);

const CircleBox = ({
  title,
  description,
  colorClass = "gradient-green",
  image,
}) => (
  <Box
    className={`circleBox ${colorClass}`}
    sx={{
      width: 180,
      height: 180,
      borderRadius: "50%",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      textAlign: "center",
      padding: 4,
      m: "auto",
    }}
  >
    <img
      src={image || imgUrl.defaultIcon}
      alt={`${title} icon`}
      style={{ width: 40, height: 40, marginBottom: 1 }}
    />
    <Typography variant="subtitle1" fontWeight="bold">
      {title}
    </Typography>
    <Typography variant="body2" sx={{ fontSize: "0.8rem" }}>
      {description}
    </Typography>
  </Box>
);

const BlockCard = ({  title,
  description,
  colorClass = "gradient-green",
  image, }) => (
  <Paper elevation={3} className="infoCard">
     <img
      src={image || imgUrl.defaultIcon}
      alt={`${title} icon`}
      style={{ width: 40, height: 40, marginBottom: 1 }}
    />
    <Typography variant="" fontWeight="bold">
      {title}
    </Typography>
    <Typography variant="body2" sx={{ fontSize: "0.8rem", fontFamily: 'var(--primary-font)', fontWeight: 400 }}>
      {description}
    </Typography>
  </Paper>
);

const Cafee = () => {
  return (
    <>
          {/* Influencer Hero Background Section */}
      <Box
        className="programCafeSectionBg commonBannerBg"
        sx={{
          backgroundSize: "cover",
          backgroundPosition: "center",
          color: "white",
          px: 2,
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: 80,
            left: 0,
            display: "flex",
            alignItems: "center",
          }}
        >
          <Box
            component="img"
            src={imgUrl.doveImg}
            alt="Peace Dove Logo"
            sx={{ maxWidth: 200, height: "auto", mr: 1 }}
          />
        </Box>
      </Box>

      {/* Influencer Main Section */}
      <Box className="" mt={5} mb={5}>
          <Grid container direction="column" alignItems="center" spacing={2}>
            <Grid size={12} display="flex" alignItems="center" justifyContent="center" flexDirection="column">
              <img src={imgUrl.peaceIcon} className="w-100 peaceImg"></img>
              <Typography variant="h1" className="founder-title mainHeading green-title" sx={{ fontFamily: 'var(--heading-font)', fontWeight: 400 }}>
                <i> I Am Peacekeeper </i> Cafee 
              </Typography>
            </Grid>

          </Grid>

        </Box>  


      {/* Top Section UI */}
       <Box className="schoolProgramMainSection topBlockBox" mt={5}>
               {/* <Typography
                          variant="h5"
                          align="center"
                          fontWeight="bold"
                          gutterBottom
                          className="subHeading"
                          pt={5}
                        >
                         TOP
                        </Typography> */}
                  <Container className="paddingSubContainer">
                           <Grid container spacing={1} mt={5} mb={2} justifyContent="center">
                             {highlights.map((item, index) => (
                                <Grid size={{xs: 12, md: 3, sm: 6  }} key={index}>
                                                  <BlockCard title={item.title}
                                   description={item.description}
                                   colorClass={item.colorClass}
                                   image={item.image} 
                                                   />
                                                </Grid>
                             ))}
                           </Grid>
                         </Container>
              </Box>
                {/* why join */}
                <Box mt={5} className="programCardMain corporateMainSection mt-50px">
                                <Typography
                                  variant="h2"
                                  align="center"
                                  fontWeight={400}
                                  gutterBottom
                                  className="subHeading mb-0px"
                                  sx={{ fontFamily: 'var(--heading-font)' }}
                                >
                                  Why Join
                                </Typography>
                                {/* <p align="center">
                                  Your organization’s partnership directly supports your Corporate
                                  Social <br></br> Responsibility (CSR) goals
                                </p> */}
                      
                                <Container className="paddingSubContainer programCardContainer mt-30px circleMainBig">
                                  <Grid
                                    container
                                    spacing={2}
                                    mt={1}
                                    justifyContent="center"
                                    alignItems="center"
                                    display="flex"
                                  >
                                    {whyJoin.map((text, index) => (
                                      <Grid
                                        size={{ xs: 12, md: 3, sm: 4 }}
                                        key={index}
                                        justifyContent="center"
                                        alignItems="center"
                                        display="flex"
                                      >
                                        <ProgramCard text={text} />
                                      </Grid>
                                    ))}
                                  </Grid>
                                </Container>
                              </Box>
                {/* How It Works */}
                               <Box className="schoolProgramMainSection">
                                  <Typography
                                         variant="h2"
                                         align="center"
                                         fontWeight={400}
                                         gutterBottom
                                         mt={5}
                                         className="subHeading mt-50px"
                                         sx={{ fontFamily: 'var(--heading-font)' }}
                                       >
                                        What You Experience
                                       </Typography>
                                       <Container className="paddingSubContainer">
                                         <Grid container spacing={1} mt={5} mb={2} justifyContent="center">
                                           {whatExperience.map((text, index) => (
                                             <Grid size={{ xs: 12, md: 3, sm: 6 }} key={index}>
                                               <InfoCard text={text} 
                                                />
                                             </Grid>
                                           ))}
                                         </Grid>
                                       </Container>
                               </Box>  

                               {/* closing */}
                                                      <Box
                                                        sx={{
                                                          textAlign: "center",
                                                          borderRadius: 3,
                                                          marginBottom:'70px'
                                                        }}
                                                        mt={5}
                                                        className="TabPaddingContainer circleClosingBig">
                                                       {/* Title */}
                                                        <Typography
                                                          variant="h2"
                                                          fontWeight={400}
                                                          gutterBottom
                                                          className="subHeading"
                                                          sx={{ fontFamily: 'var(--heading-font)' }}
                                                        >
                                                        Closing
                                                        </Typography>
                                                       <Container className="paddingContainer mt-50px" mb={5}>
                                                          <Grid container spacing={7} justifyContent="center" mb={4}>
                                                            {circleCourses.map(({ text, colorClass }, index) => (
                                                              <Grid size={{ xs: 12, sm: 3, md: 2 }} key={index}>
                                                                <ConclusionCard text={text} colorClass={colorClass} />
                                                              </Grid>
                                                            ))}
                                                          </Grid>
                                                        </Container>
                                                 </Box>     


    </>
  )
}

export default Cafee